import {Appointment, Page} from "@/libwyze-shared/types";
import React, {ReactElement, useEffect, useState} from "react";
import {Box, Card, CircularProgress, Typography, useTheme} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {CheckinScreenType, CheckinState} from "./CheckinPlayerPreviewFragment";
import {CheckinLargeButton} from "@/checkin-shared/Components";
import {ArrowForwardOutlined, CalendarMonthOutlined, PersonOutlined,} from "@mui/icons-material";
import {BORDER_RADIUS_MEDIUM, PD_LG, PD_MD, PD_XLG2, PD_XSM, SZ_MD} from "@/shared/dimens";
import {ProfilePhoto} from "@/shared/types";
import {DateUtil, FORMAT_SHOW_TIME, FORMAT_SHOW_YEAR} from "@/shared/date_util";

function DetailRow(props: { icon: ReactElement, label: string, value: string }): ReactElement {
  return <StyledBoxRow style={{alignItems: "center", gap: PD_MD}}>
    <StyledBoxRow style={{alignItems: "center", gap: PD_XSM, width: 120}}>
      {props.icon}
      <Typography variant="caption" style={{fontWeight: 600, textTransform: "uppercase", opacity: 0.5}}>
        {props.label}
      </Typography>
    </StyledBoxRow>
    <Typography style={{fontWeight: 500}}>
      {props.value}
    </Typography>
  </StyledBoxRow>;
}

export function AppointmentConfirmScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void,
}): ReactElement {
  const theme = useTheme();
  const [appointment, setAppointment] = useState<Appointment>();
  useEffect(() => {
    (async function () {
      setAppointment(null);
      // setAppointment((await PracticeData.provider().appointments.getOrLoadListItems())?.[0] || null);
    })();
  }, []);
  const patientProfile = appointment?.patient;
  return appointment !== undefined
    ? (Boolean(appointment)
      ? <>
        <StyledBoxColumn style={{alignItems: "flex-start", gap: 0}}>
          <Typography variant={"h2"} style={{fontWeight: 900}}>
            Is this you?
          </Typography>
          <Typography style={{fontSize: "100%", opacity: 0.5}}>
            Please confirm the details below.
          </Typography>
        </StyledBoxColumn>
        <Box style={{
          width: "100%",
          borderRadius: BORDER_RADIUS_MEDIUM,
          backgroundColor: theme.palette.grey[100],
          padding: PD_LG,
        }}>
          <StyledBoxRow style={{alignItems: "start", gap: PD_LG}}>
            <Card style={{width: SZ_MD, height: SZ_MD, flexShrink: 0}}>
              <img src={ProfilePhoto(patientProfile.basicInfo.profilePhoto)}
                   style={{width: "100%", height: "100%", objectFit: "cover"}}/>
            </Card>
            <StyledBoxColumn style={{flex: 1}}>
              <Typography variant="h5" style={{fontWeight: 700}}>
                {patientProfile.displayName()}
              </Typography>
              <Typography style={{opacity: 0.5}}>
                {patientProfile.basicInfo.dateOfBirthText()} · {patientProfile.basicInfo.phoneNumber}
              </Typography>
              <DetailRow
                icon={<CalendarMonthOutlined style={{fontSize: "100%", opacity: 0.5}}/>}
                label="Appointment"
                value={DateUtil.formatDateTime(appointment.scheduled, FORMAT_SHOW_TIME | FORMAT_SHOW_YEAR)}
              />
              {/*<DetailRow*/}
              {/*  icon={<MedicalServicesOutlined style={{fontSize: "100%", opacity: 0.5}}/>}*/}
              {/*  label="Procedure"*/}
              {/*  value={procedure}*/}
              {/*/>*/}
              <DetailRow
                icon={<PersonOutlined style={{fontSize: "100%", opacity: 0.5}}/>}
                label="Provider"
                value={appointment.provider.displayName()}
              />
            </StyledBoxColumn>
          </StyledBoxRow>
        </Box>
        <StyledBoxRow style={{gap: PD_MD}}>
          <CheckinLargeButton
            endIcon={<ArrowForwardOutlined style={{fontSize: "125%"}}/>}
            onClick={() => {
              props.pushScreenType(CheckinScreenType.CHECKIN_PROGRESS);
            }}>
            Yes, that's me
          </CheckinLargeButton>
          <CheckinLargeButton
            variant="outlined"
            onClick={() => {
              props.pushScreenType(CheckinScreenType.FIND_APPOINTMENT);
            }}>
            That's not me
          </CheckinLargeButton>
        </StyledBoxRow>
        <StyledSpan/>
      </>
      : <StyledBoxColumn style={{flexGrow: 1, gap:PD_XLG2, alignItems: "center", justifyContent: "center"}}>
        <Typography style={{textAlign: "center"}} variant={"h4"}>
          Appointment not found
        </Typography>
        <Typography style={{textAlign: "center"}}>
          Please approach the reception for help or try again.
        </Typography>
        <CheckinLargeButton
          variant="outlined"
          onClick={() => {
            props.pushScreenType(CheckinScreenType.FIND_APPOINTMENT);
          }}>
          Try again
        </CheckinLargeButton>
      </StyledBoxColumn>)
    : <CircularProgress/>;
}
